import Vue from 'vue';
import VueRouter from 'vue-router';

import Apps from '@/pages/Apps.vue';
import Career from '@/pages/Career2.vue';
import Hardware from '@/pages/Hardware.vue';
import Home from '@/pages/Home.vue';
import Press from '@/pages/Press.vue';
import Covid from '@/pages/Covid.vue';
import LegalNotice from '@/pages/LegalNotice.vue';
import Tos from '@/pages/Tos.vue';
import Tou from '@/pages/Tou.vue';
import Pp from '@/pages/Pp.vue';

Vue.use(VueRouter);

/* eslint-disable object-curly-newline */
const routes = [
  { path: '/apps', name: 'apps', component: Apps, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/career', name: 'career', component: Career, beforeEnter() { window.location.href = 'https://mwm.io/career-at-mwm'; } },
  { path: '/hardware', name: 'hardware', component: Hardware, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/', name: 'home', component: Home, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/press', name: 'press', component: Press, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/covid', name: 'covid', component: Covid, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/legal-notice', name: 'legal-notice', component: LegalNotice, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/products', name: 'products', component: Tos, beforeEnter() { window.location.href = 'https://mwm.io'; } },
  { path: '/products/:app_key/tos', name: 'tos', component: Tos },
  { path: '/products/:app_key/tou', name: 'tou', component: Tou },
  { path: '/products/:app_key/policies', name: 'pp', component: Pp },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // proceed
  next();
});

export default router;
